import { render, staticRenderFns } from "./RekognitionForm.vue?vue&type=template&id=22ee9dde&scoped=true&"
import script from "./RekognitionForm.vue?vue&type=script&lang=js&"
export * from "./RekognitionForm.vue?vue&type=script&lang=js&"
import style0 from "./RekognitionForm.vue?vue&type=style&index=0&id=22ee9dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee9dde",
  null
  
)

export default component.exports